import { createFileRoute } from "@tanstack/react-router";

import { HomeView } from "@/components/home/HomeView";
import { Footer } from "@/components/layout/Footer";
import { JsonLd } from "@/components/layout/JsonLd";
import { Navbar } from "@/components/layout/Navbar";
import { meta } from "@/content/meta";
import {
  defaultLocale,
} from "@/i18n/locales";
import {
  seoHead,
} from "@/lib/site";
import { homeJsonLd } from "@/lib/schema";

export const Route = createFileRoute("/")({
  head: () => ({
    ...seoHead({
      locale: defaultLocale,
      path: "/",
      ...meta.nl.home,
      smartBanner: true,
    }),
  }),
  component: IndexRoute,
});

function IndexRoute() {
  return (
    <>
      <JsonLd data={homeJsonLd(defaultLocale)} />
      <Navbar locale={defaultLocale} />
      <HomeView locale={defaultLocale} />
      <Footer locale={defaultLocale} />
    </>
  );
}
